import Vue from 'vue'
import VueRouter from 'vue-router'
import {permission} from './permission';

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    redirect:'/index.vue'
  },
  {
    path:'/index',
    name: 'index',
    component: () => import('@/views/qrcode/index.vue'),
  },
  {
    path:'/bindCard',
    name: 'bindCard',
    component: () => import('@/views/binding/index.vue'),
  },
  {
    path:'/main',
    name: 'main',
    component: () => import('@/views/main/index.vue'),
  },
  {
    path:'/historyOrder',
    name: 'historyOrder',
    component: () => import('@/views/historyOrder/index.vue'),
  },
  {
    path:'/orderDetail',
    name: 'orderDetail',
    component: () => import('@/views/orderDetail/index.vue'),
  },
  {
    path:'/coupon',
    name: 'coupon',
    component: () => import('@/views/coupon/index.vue'),
  },
  {
    path:'/userInfo',
    name: 'userInfo',
    component: () => import('@/views/userInfo/index.vue'),
  },
  {
    path:'/PayCard',
    name: 'PayCard',
    component: () => import('@/views/PayCard/index.vue'),
  },
  {
    path:'/PayCard2',
    name: 'PayCard2',
    component: () => import('@/views/PayCard2/index.vue'),
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('@/views/pay/index.vue')
  },
  

  
  




  //404
  {
    path:"*",
    redirect:'/index'
  }
]


const router = new VueRouter({
  base: process.env.BASE_URL,
  mode:'history',
  routes
})

// 权限
permission(router);

export default router